export var getCustomElement = function getCustomElement(isDisabled, href, onClick) {
  if (href && !isDisabled) {
    return 'a';
  }
  if (onClick || isDisabled) {
    return 'button';
  }
  return 'span';
};